<rappider-crud-view [modelNameSingular]="modelNameSingular"
                    [mainTitleConfig]="mainTitleConfig!"
                    [mainTitleConfigs]="mainTitleConfigs!"
                    [viewMode]="viewMode"
                    [listMode]="ListMode.Card"
                    [showCreateButton]="true"
                    [createButtonTitle]="createItemTitle"
                    [displayToolbarBackButton]="true"
                    [listGridData]="entities ?? []"
                    [activeItem]="activeItem"
                    [activeItemId]="activeItemId"
                    [listGridConfig]="listGridConfig"
                    [cardListConfig]="cardListConfig"
                    [createFormConfig]="createItemFormConfig!"
                    [updateFormConfig]="updateItemFormConfig!"
                    [updateFormData]="activeItem"
                    [isListGridDataLoading]="isEntityDataLoaded ? true: isListGridDataLoading"
                    (createFormSubmit)="onCreateFormSubmit($event)"
                    (updateFormSubmit)="onUpdateFormSubmit($event)"
                    (itemDeleted)="onItemDeleted($event)"
                    (titleBarActionButtonClicked)="onTitleBarActionButtonClicked($event)">
</rappider-crud-view>
<rappider-ai-function-execute></rappider-ai-function-execute>
